import { CrmReportDimension, CrmReportEntity } from '../../../api/CRMApiClient';

export type ReportChartType = 'bar' | 'pie' | 'stackedBar';

export interface ReportDefinition {
  key: string;
  titleKey: string;
  entity: CrmReportEntity;
  groupBy: CrmReportDimension;
  secondaryGroupBy?: CrmReportDimension;
  chart: ReportChartType;
}

/** The four reports the customer asked for. The custom form produces the same shape. */
export const REPORT_PRESETS: ReportDefinition[] = [
  { key: 'companiesByUser', titleKey: 'CompaniesByUser', entity: 'Companies', groupBy: 'User', chart: 'bar' },
  { key: 'contactsByUser', titleKey: 'ContactsByUser', entity: 'Contacts', groupBy: 'User', chart: 'bar' },
  { key: 'eventsByUser', titleKey: 'EventsByUser', entity: 'Events', groupBy: 'User', chart: 'bar' },
  { key: 'eventsByPeriodCountry', titleKey: 'EventsByPeriodAndCountry', entity: 'Events', groupBy: 'Period', secondaryGroupBy: 'Country', chart: 'stackedBar' },
  { key: 'eventsByCity', titleKey: 'EventsByCity', entity: 'Events', groupBy: 'City', chart: 'bar' },
  { key: 'companiesByCountry', titleKey: 'CompaniesByCountry', entity: 'Companies', groupBy: 'Country', chart: 'pie' },
];

export const ENTITY_OPTIONS: CrmReportEntity[] = ['Companies', 'Contacts', 'Events'];
export const DIMENSION_OPTIONS: CrmReportDimension[] = ['User', 'Country', 'City', 'Period', 'Category', 'EventType', 'ClientRole'];
export const CHART_OPTIONS: ReportChartType[] = ['bar', 'pie', 'stackedBar'];

export const CHART_COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d', '#a4de6c', '#d0ed57', '#ffc658', '#8dd1e1'];
